<template
  src="./index.html"
  lang="html"></template>
<style
  src="../../stylus/main.css"
  lang="css">
</style>

<script>
  export default {
    name: 'prv-input',
    computed: {
      computedErrors () {
        return typeof this.errorMessages === 'string'
          ? [this.errorMessages] : this.errorMessages
      },
      computedClasses () {
        return {
          'material--active': this.focus,
          'material--disabled': this.disabled,
          'material--has-errors': Boolean(
            !this.valid ||
            (this.errorMessages && this.errorMessages.length)),
          'material--raised': Boolean(
            this.focus ||
            this.valueCopy || // has value
            (this.placeholder && !this.valueCopy)) // has placeholder
        }
      }
    },
    data () {
      return {
        valueCopy: null,
        focus: false,
        valid: true,
        hasHidePassword: true
      }
    },
    beforeMount () {
      // Here we are following the Vue2 convention on custom v-model:
      // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
      this.copyValue(this.value)
    },
    methods: {
      handleModelInput (event) {
        this.$emit('input', event.target.value, event)
        this.handleValidation()
      },
      handleFocus (focused) {
        this.focus = focused
      },
      handleValidation () {
        this.valid = this.$el ? this.$el.querySelector(
          '.material-input').validity.valid : this.valid
      },
      copyValue (value) {
        this.valueCopy = value
        this.handleValidation()
      },
      switchVisibility() {
        const passwordField = document.querySelector(`#${this.id}`);

        if (passwordField.getAttribute('type') === 'password') {

          this.hasHidePassword = false;

          passwordField.setAttribute('type', 'text')
        } else {

          this.hasHidePassword = true;

          passwordField.setAttribute('type', 'password')
        }
      }
    },
    watch: {
      value (newValue) {
        // This watch works from the code side of the 2-way-binding:
        this.copyValue(newValue)
      }
    },
    props: {
      id: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null
      },
      type: {
        type: String,
        default: 'text'
      },
      value: {
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      min: {
        type: String,
        default: null
      },
      max: {
        type: String,
        default: null
      },
      step: {
        type: Number,
        default: null
      },
      minlength: {
        type: Number,
        default: null
      },
      maxlength: {
        type: Number,
        default: null
      },
      required: {
        type: Boolean,
        default: true
      },
      autocomplete: {
        type: String,
        default: null
      },
      errorMessages: {
        type: [Array, String],
        default: null
      }
    }
  }
</script>